import createCache from '@emotion/cache';
var createEmotionCache = function () { return createCache({ key: 'css' }); };
export default createEmotionCache;
